import { FC } from 'react';
import { LinkWithQuery } from '@components/linkwithquery';
import { CUSTOMISE_SEARCH } from '@navigation/constants';
import { useAppSelector } from '@hooks/statehooks';
import { useSelectedOptions } from '@hooks/useselectedoptions';
import useToggleLiveChat from '@hooks/usetogglelivechat';

interface CustomiseCarButtonProps {
  className?: string;
  changeOptions?: boolean;
}
const CustomiseButton: FC<CustomiseCarButtonProps> = ({
  className,
  changeOptions,
}) => {
  const { getNumberOfExtrasSelected, getTotalCostOfExtrasSelected } =
    useSelectedOptions();
  const pricingState = useAppSelector((state) => state.pricingState);
  const vehicleSearchParams = useAppSelector(
    (state) => state.vehicleSearchParams
  );

  const customiseButtonText = changeOptions
    ? 'Change options'
    : 'Select options';

  const fireDatalayerEvent = () => {
    window.dataLayer = window.dataLayer || [];
    if (changeOptions) {
      window.dataLayer.push({
        event: 'configureOptions',
        category: 'Change Options',
        action: 'click',
        lease: {
          no_of_extras: getNumberOfExtrasSelected(),
          cost_of_extras: getTotalCostOfExtrasSelected(),
        },
      });
    } else {
      window.dataLayer.push({
        event: 'configureOptions',
        category: 'Select Options',
        action: 'click',
      });
    }
  };

  const { hideElement } = useToggleLiveChat();

  const handleClick = () => {
    fireDatalayerEvent();
    hideElement();
  };

  return (
    <LinkWithQuery
      onClick={handleClick}
      className={className}
      to={CUSTOMISE_SEARCH(vehicleSearchParams)}
      disabled={!pricingState.finished}
    >
      {customiseButtonText}
    </LinkWithQuery>
  );
};

export default CustomiseButton;
